import { memo, useMemo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { QueryData } from "../../../model";

type Props = {
	// 宿泊券
	vouchers?: InputMaybe<QueryData["aliveItemsPerReservation"]["vouchers"]>;
};

export const VoucherOfVoucherAndDiscountCompositions = memo(({ vouchers }: Props) => {
	/**
	 * 宿泊券をリストとして整形
	 */
	const voucherList = useMemo(() => {
		if (!vouchers || vouchers.length === 0) return [{ name: "宿泊券は使用されていません", price: "¥ 0" }];

		return vouchers.map((voucher) => ({ name: voucher.name, price: `− ¥ ${voucher.voucherPrice}` }));
	}, [vouchers]);

	return (
		<div className="space-y-2">
			{voucherList.map((voucher, index) => {
				return (
					<div key={index} className="space-y-4">
						<p className="font-medium">{voucher.name}</p>
						<p className="text-right">{voucher.price}</p>
					</div>
				);
			})}
		</div>
	);
});
